import { render, staticRenderFns } from "./PanelLink.vue?vue&type=template&id=b5142cc0"
import script from "./PanelLink.vue?vue&type=script&lang=js"
export * from "./PanelLink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports